import add_work_equipment from "./add_work_equipment";
import templates_form from "./templates_form";
import workflow_metric_form from "./workflow_metric_form";

export default {
  add_work_equipment: add_work_equipment,
  templates_form: templates_form,
  workflow_metric_form: workflow_metric_form,
};
